/**
 * NotifySignupFAB
 *
 * モーダルを閉じた後も右下に常駐する「公開のお知らせを受け取る」 FAB。
 * クリックでモーダル再表示。
 */
import React, { useState } from 'react';
import { Fab, Tooltip, Zoom } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import NotifySignupModal, { STORAGE_REGISTERED_KEY } from './NotifySignupModal';

const PRIMARY = '#4f46e5';

const NotifySignupFAB = ({ visible = true }) => {
  const [open, setOpen] = useState(false);
  const registered = (() => {
    try { return localStorage.getItem(STORAGE_REGISTERED_KEY) === '1'; } catch { return false; }
  })();

  // 既に登録済みの場合は FAB を出さない
  if (registered || !visible) return null;

  return (
    <>
      <Zoom in>
        <Tooltip title="近日公開予定 ・ 公開時にメールでお知らせします" placement="left" arrow>
          <Fab
            onClick={() => setOpen(true)}
            aria-label="公開のお知らせを受け取る"
            sx={{
              position: 'fixed',
              bottom: { xs: 16, md: 24 },
              right: { xs: 16, md: 24 },
              zIndex: 1200,
              bgcolor: PRIMARY,
              color: '#fff',
              width: 52,
              height: 52,
              boxShadow: '0 4px 14px rgba(79,70,229,0.4)',
              '&:hover': {
                bgcolor: '#4338ca',
                boxShadow: '0 6px 20px rgba(79,70,229,0.55)',
              },
            }}
          >
            <NotificationsActiveIcon />
          </Fab>
        </Tooltip>
      </Zoom>
      <NotifySignupModal open={open} onClose={() => setOpen(false)} onRegistered={() => setOpen(false)} />
    </>
  );
};

export default NotifySignupFAB;
